import Spinner from "components/Spinner";
import { setNotification } from "features/Notification/notificationSlice";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import authHeader from "services/auth-header";
import API from "services/axios";

// import DeleteModalButton from "components/DeleteModalBtn/DeleteModalButton";
import AttDailyLogs from "./DailyLogs/AttDailyLogs";
import UpdateMonthlyRecords from "./UpdateMonthlyRecords";
import AttUserInfo from "./UserDetails/AttUserInfo";
import NightUpdateMonthlyRecords from "./NightOffcUser/NightUpdateMonthlyRecords";

export default function AttendanceDetailsPage() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const params = useParams();
  /*   All States
   ********************************************* */

  const [userAttendanceLogs, setUserAttendanceLogs] = useState(null);
  const [userData, setUserData] = useState(null);

  const [activeTab, setActiveTab] = useState("by-month");

  const [selectedMonth, setSelectedMonth] = useState(() => {
    const currentDate = new Date();
    return `${currentDate.getFullYear()}-${String(
      currentDate.getMonth() + 1,
    ).padStart(2, "0")}`;
  });

  // Set default dates to last three months
  const [startDate, setStartDate] = useState(() => {
    const now = new Date();
    const threeMonthsAgo = new Date(now);
    threeMonthsAgo.setMonth(now.getMonth() - 3);
    return threeMonthsAgo.toISOString().slice(0, 10).replace("T", " ");
  });

  const [endDate, setEndDate] = useState(
    new Date().toISOString().slice(0, 10).replace("T", " "),
  );

  const [logsLastSync, setLogsLastSync] = useState(null);

  const [loading, setLoading] = useState(false);

  const loadingOn = () => {
    setLoading(true);
  };

  const loadingOff = () => {
    setLoading(false);
  };

  /*   All Functions
   ********************************************* */
  const getLogsByDate = async () => {
    try {
      // increment 1 to endDate
      const endDateObj = new Date(endDate);
      endDateObj.setDate(endDateObj.getDate() + 1);

      // get only date frm endDateObj not time
      const endDateString = endDateObj.toISOString().slice(0, 10);

      // get year from startDate
      const year = new Date(startDate).getFullYear();

      loadingOn();
      const { data } = await API.post(
        "/get-user-logs/" + params.userId,
        {
          deviceId: params.deviceId,
          startDate,
          endDate: endDateString,
          year: year,
        },
        {
          headers: authHeader(),
        },
      );

      if (data?.success) {
        setUserAttendanceLogs(data?.data);
      } else {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }
      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const getUserInfoByID = async () => {
    try {
      let userId = params.userId;
      let deviceId = params.deviceId;

      if (!userId || !deviceId) {
        return;
      }
      loadingOn();
      const { data } = await API.get(
        "/device-user-id/" + deviceId + "/" + userId,
        {
          headers: authHeader(),
        },
      );
      if (data?.success) {
        setUserData(data?.data);
      }
      if (!data?.success) {
        dispatch(
          setNotification({
            message: data?.message,
            type: "error",
          }),
        );
      }

      loadingOff();
    } catch (err) {
      loadingOff();
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    }
  };

  const parsedRecordTime = (recordTime) => {
    const date = new Date(recordTime);

    // Use UTC methods to get the original time
    let hours = date.getUTCHours();
    let minutes = date.getUTCMinutes();

    const meridiem = hours >= 12 ? "PM" : "AM";
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    minutes = minutes < 10 ? "0" + minutes : minutes;
    let strTime = hours + ":" + minutes + " " + meridiem;
    return strTime;
  };

  const parsedRecordDate = (recordTime) => {
    const date = new Date(recordTime);
    return date.toUTCString().slice(0, 16);
  };

  // Get Device Details
  const getDeviceDetails = async (id) => {
    try {
      loadingOn();
      const { data } = await API.get("/get-attendance-device/" + id, {
        headers: authHeader(),
      });

      if (data?.success) {
        // setSelectedDevice(data?.data);
        setLogsLastSync(data?.data?.lastLogsSync);
      }
      if (!data?.success) {
        dispatch(
          setNotification({
            message: data.message,
            type: "error",
          }),
        );
      }
    } catch (err) {
      dispatch(
        setNotification({
          message: err.message,
          type: "error",
        }),
      );
    } finally {
      loadingOff();
    }
  };

  /*   All UseEffects
   ********************************************* */
  useEffect(() => {
    let clearTimeoutId = setTimeout(() => {
      let deviceId = params.deviceId;
      if (!deviceId) {
        return;
      }
      getUserInfoByID();
      getLogsByDate();
      getDeviceDetails(deviceId);
    }, 500);
    return () => clearTimeout(clearTimeoutId);
  }, [params]);

  return (
    <div
      style={{
        marginLeft: 280,
        height: "100vh",
        overflowY: "auto",
        // paddingRight: 10,
      }}
      className="pe-2"
    >
      {loading && <Spinner />}
      <div
        style={{
          height: "15vh",
        }}
        className="me-2"
      >
        <h1 className="mt-0 pt-1">Detail Page</h1>

        <div className="d-flex justify-content-between align-items-center mb-3">
          <div className="d-flex align-items-center gap-2 justify-content-between ">
            <ul className="nav nav-tabs nav-bordered border-0 d-flex flex-grow-1">
              <li className="">
                <button
                  className={
                    activeTab === "by-month" ?
                      `btn btn-primary active bg-primary text-white`
                    : "btn bg-white shadow-sm"
                  }
                  onClick={() => setActiveTab("by-month")}
                >
                  <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                  <span className="d-none d-md-block">By-Month</span>
                </button>
              </li>
              <li className="">
                <button
                  className={
                    activeTab === "daily-log" ?
                      `btn btn-primary active bg-primary text-white`
                    : "btn bg-white shadow-sm"
                  }
                  onClick={() => setActiveTab("daily-log")}
                >
                  <i className="mdi mdi-settings-outline d-md-none d-block"></i>
                  <span className="d-none d-md-block">Daily-log</span>
                </button>
              </li>
            </ul>
            <span className="ms-3">
              <span className="fw-bold">Logs Last Sync: </span>
              {logsLastSync ?
                `${parsedRecordDate(logsLastSync)} at ${parsedRecordTime(
                  logsLastSync,
                )}`
              : "Never"}
            </span>
          </div>
          <button
            type="button"
            className="btn btn-danger"
            onClick={() => {
              navigate("/attendance?deviceId=" + params.deviceId);
            }}
          >
            Back
          </button>
        </div>
      </div>

      <div
        className="row mx-0"
        style={{
          height: "82vh",
          overflowY: "auto",
        }}
      >
        {activeTab === "by-month" && (
          <div className="col-md-8 bg-white shadow-sm rounded-3 relative">
            {userData ?
              <>
                {userData?.isNightOffice ?
                  <NightUpdateMonthlyRecords
                    userData={userData}
                    setUserData={setUserData}
                    refreshFunc={getLogsByDate}
                    selectedMonth={selectedMonth}
                    setSelectedMonth={setSelectedMonth}
                  />
                : <UpdateMonthlyRecords
                    setUserData={setUserData}
                    refreshFunc={getLogsByDate}
                    selectedMonth={selectedMonth}
                    setSelectedMonth={setSelectedMonth}
                  />
                }
              </>
            : <>
                <Spinner />
              </>
            }
          </div>
        )}
        {activeTab === "daily-log" && (
          <div className="col-md-8">
            <AttDailyLogs
              parsedRecordTime={parsedRecordTime}
              parsedRecordDate={parsedRecordDate}
              getLogsByDate={getLogsByDate}
              startDate={startDate}
              setStartDate={setStartDate}
              endDate={endDate}
              setEndDate={setEndDate}
              userAttendanceLogs={userAttendanceLogs}
              setUserAttendanceLogs={setUserAttendanceLogs}
              userData={userData}
            />
          </div>
        )}

        <div className="col-md-4">
          {/*   User Info
           ********************************************* */}

          <AttUserInfo userData={userData} refreshFunc={getUserInfoByID} />
        </div>
      </div>
    </div>
  );
}
